module.exports = __webpack_public_path__ + "img/icon-historical-menu-covid.7b07dec2.svg";